(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    (function() {
  function initCarouselDots() {
    document.querySelectorAll('slideshow-component.carousel-content').forEach(function(slideshowEl) {
      if (slideshowEl.dataset.dotsInit) return;
      slideshowEl.dataset.dotsInit = '1';

      var slideEls = Array.from(slideshowEl.querySelectorAll('slideshow-slides > *'));
      if (slideEls.length <= 1) return;

      var dotsContainer = document.createElement('div');
      dotsContainer.className = 'carousel-dots';

      slideEls.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'carousel-dot';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', function() {
          if (typeof slideshowEl.select === 'function') slideshowEl.select(i);
        });
        dotsContainer.appendChild(dot);
      });

      slideshowEl.appendChild(dotsContainer);

      var scroller = slideshowEl.querySelector('slideshow-slides');
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio > 0.6) {
            var idx = slideEls.indexOf(entry.target);
            if (idx !== -1) {
              dotsContainer.querySelectorAll('.carousel-dot').forEach(function(dot, i) {
                dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
              });
            }
          }
        });
      }, { threshold: 0.6, root: scroller });

      slideEls.forEach(function(slide) { observer.observe(slide); });
    });
  }

  if (customElements.get('slideshow-component')) {
    initCarouselDots();
  } else {
    customElements.whenDefined('slideshow-component').then(initCarouselDots);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
